const WithdrawIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 7V11H5.83L9.41 7.41L8 6L2 12L8 18L9.41 16.58L5.83 13H21V7H19Z" fill="#5E5E5E" />
        </svg>
    );
};

export default WithdrawIcon;
